import React from "react"
import { Button, Container, Figure } from "react-bootstrap"
import Layout from "../components/Layout"
import { Seo } from "../components/Seo"
import { useLocation } from "@reach/router"
import greenArrow from "../assets/svgs/Arrow.svg"

export default function NotFound() {
  const logo404 =
    "https://cdn.sanity.io/images/3hfxs7a8/production/2ce6bcc65209dec2db5bb9b414469ce051763fb4-1514x862.webp"
  const pathLocation = useLocation()
  const url = pathLocation.href
  return (
    <Layout>
      <Seo title="404 Page" url={url} />
      <div className="not-found">
        <Container className="d-flex flex-column align-items-center scroll-show">
          <p className="title">ERROR</p>
          <img className="logo-404 my-5" src={logo404} alt="404 logo"></img>
          <p className="title bordered-title p-1 mb-5">
            It seems the page you’re looking for has been optimized out of
            existence
          </p>
          <div className="d-flex justify-content-between gap mobile-column">
            <button
              className="contact-us-link button-padding hover-state mob-width pt-0"
              onClick={() => (window.location.href = "/")}
            >
              <span className="c-us">Go to Homepage</span>
            </button>

            <button
              className="contact-us-link button-padding hover-state mob-width pt-0 secondary-contact-us green dark-green-hover"
              onClick={() => (window.location.href = "/contact")}
            >
              <span className="c-us">
                Contact Us{" "}
                <span>
                  <img
                    className="pb-1"
                    src={greenArrow}
                    alt="Green Arrow"
                  ></img>
                </span>
              </span>
            </button>
          </div>
        </Container>
      </div>
    </Layout>
  )
}
